import { create } from 'zustand';
import { api, ApiError, type Me } from '@/api/client';

interface AuthState {
  me: Me | null;
  status: 'unknown' | 'anonymous' | 'signed-in';
  error: string | null;
  refresh: () => Promise<void>;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  acceptResearchUse: () => Promise<void>;
}

export const useAuth = create<AuthState>((set) => ({
  me: null,
  status: 'unknown',
  error: null,
  refresh: async () => {
    try {
      const me = await api.get<Me>('/api/me');
      set({ me, status: 'signed-in', error: null });
    } catch (e) {
      if (e instanceof ApiError && e.status === 401) set({ me: null, status: 'anonymous' });
      else set({ me: null, status: 'anonymous', error: (e as Error).message });
    }
  },
  login: async (email, password) => {
    set({ error: null });
    try {
      await api.post('/api/auth/login', { email, password });
      const me = await api.get<Me>('/api/me');
      set({ me, status: 'signed-in' });
    } catch (e) {
      set({ error: (e as Error).message });
      throw e;
    }
  },
  logout: async () => {
    await api.post('/api/auth/logout');
    set({ me: null, status: 'anonymous' });
  },
  acceptResearchUse: async () => {
    await api.post('/api/me/research-use-acceptance');
    const me = await api.get<Me>('/api/me');
    set({ me });
  },
}));
